import useLogout from "@ch/helpers/hooks/useLogout";
import { closeLogoutModal } from "@ch/helpers/utils/helpers";
import type { FC } from "react";
import AlertDialogue, { type AlertDialogueProps } from "./AlertDialogue";

type LogoutConfirmModalProps = Omit<AlertDialogueProps, "children" | "modalId">;

const LogoutConfirmModal: FC<LogoutConfirmModalProps> = () => {
  const { logoutUser } = useLogout();
  return (
    <AlertDialogue
      cancelButtonProps={{
        variant: "secondary",
      }}
      closeOnClickOutside
      confirmButtonClassName="!btn-error"
      confirmButtonProps={{
        variant: "danger",
      }}
      handleCancel={closeLogoutModal}
      handleConfirm={logoutUser}
      headerTitle="Logout Confirmation"
      modalId="logout-confirm-modal"
    >
      <p className="mb-4">Hey there! just making sure that was intentional.</p>

      <p>Are you sure you want to logout?</p>
    </AlertDialogue>
  );
};

export default LogoutConfirmModal;
